export default __webpack_public_path__ + "static/media/bank_mellat.0c4be603.png";